export function formatDate(
  dateString,
  includeTime = false,
  includeDay = false,
  displayFullMonth = false
) {
  const date = new Date(dateString);

  const options = {
    year: "numeric",
    month: "long",
  };

  if (includeDay) {
    options.day = "numeric";
  }
  if (includeTime) {
    options.hour = "numeric";
    options.minute = "numeric";
    options.second = "numeric";
    options.hour12 = false;
  }

  let formattedDate = date.toLocaleDateString("en-US", options);
  if (!includeDay) {
    // If day is not included, remove the day part from formattedDate
    let formattedArray = formattedDate.split(" ");
    //formattedDate = formattedArray[0] + ", " + formattedArray[1];
    if (!displayFullMonth) {
      formattedDate = formattedArray[0].substring(0, 3);
    } else {
      formattedDate = formattedArray[0];
    }
  }

  // Add "th", "st", "nd", or "rd" to the day
  const day = date.getDate();
  const daySuffix = getDaySuffix(day);
  const formattedDay = `${day}${daySuffix}`;

  // Construct the final formatted date string
  return formattedDay + " " + formattedDate;
}

// Function to get the day suffix (e.g., "st", "nd", "rd", "th")
function getDaySuffix(day) {
  if (day >= 11 && day <= 13) {
    return "th";
  }
  switch (day % 10) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  }
}
